import React, {useState, useEffect, useRef} from 'react';
import Menu from "../../components/Menu/Menu";
import './QuizGenerator.scss';
import { getQuizList, getLastSubmitHistory } from '../../requests';
import {Button, Collapse, Card, message, Spin,Empty, Space, Modal, Select, Input, InputNumber, Divider    } from 'antd';
import { PlusCircleTwoTone, PlusCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { handleFilesUI, timeStampToDateTime } from '../../tools';
import {EditOutlined, BarChartOutlined, PlusOutlined} from '@ant-design/icons';
import useThemeItems from "../../components/useThemeItems";
import DocumentsList from '../../components/DocumentsList/DocumentsList';
import Loading from '../../components/Loading/Loading';

const { TextArea } = Input;

function Quiz (props){
    const [quizzes, setQuizzes] = useState([]);
    const [subObj, setSubObj] = useState({});
    const [messageApi, contextHolder] = message.useMessage();
    const [spinning, setSpinning] = React.useState(false);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const user = JSON.parse(localStorage.getItem('user'));
    // const items = useThemeItems(user.user_id);
    // const inputRef = useRef(null);
    // const [name, setName] = useState('');

    useEffect(()=>{
        const func = async ()=>{
            const list = await getQuizList(user.user_id);
            const res = await getLastSubmitHistory(user.user_id);
            list.forEach((ele, index) => {
                if(res[ele.quiz_id]){
                    list[index] = {...ele, ...res[ele.quiz_id]};
                }
            });
            let firstKey;
            let max;
            Object.values(res).forEach(element => {
                if(!max){
                    max = new Date(element.submit_time);
                    firstKey = element.quiz_id;
                }else{
                    if(new Date(element.submit_time) > max){
                        max = new Date(element.submit_time);
                        firstKey = element.quiz_id;
                    }
                }
            });

            if(firstKey){
                let firstSubmit = list.find(ele => ele.quiz_id == firstKey); // int equal to string
                console.log('firstSubmit', firstSubmit)
                setSubObj(firstSubmit);
            }

            setQuizzes(list)
        }
        func();
    }, [])

    const handleAddQuiz = ()=>{
        navigate('/test-generator');
    }
    
    const quizListMergeToTheme = ()=>{
        /**
         * {
         *      theme_id: [quiz1, quiz2, ...],
         *      theme_id2: [quiz1, quiz2, ...],
         * }
         */
        let res = {};

        quizzes.forEach((ele, index) => {
            if(!res[ele.theme_id]){
                res[ele.theme_id] = [ele];
            }else{
                res[ele.theme_id].push(ele);
            }
        });
        /**
         * [
         *      {
         *          theme_id: id,
         *          theme_name: name,
         *          quizUnderTage: [quizzes]
         *      }
         * ]
         */
        const resList = [];
        for (const key in res) {
            if (Object.hasOwnProperty.call(res, key)) {
                const element = res[key]; // quizzes
                resList.push({
                    theme_id: key,
                    theme_name: res[key][0].theme_name,
                    quizUnderTag: element,
                })
            }
        }

        console.log('resList', resList)
        return resList; 
    }

    const goQuiz = async(e, quiz)=>{
        console.log('quiz', quiz);
        // e.preventDefault();
        // setOpen(true);
        // return;
        // if(theme){
            
        //     return;
        // }
        // setSpinning(true);
        // const questionList = await getQuizDetail(quizId, quizType);
        // setSpinning(false);
        navigate('/quiz', {
            state: {
                quiz_id: quiz.quiz_id,
                attemp: quiz.attemp,
                questionIdList: quiz.content,
            }
        });
    }
    // const onNameChange = (event) => {
    //     setName(event.target.value);
    // };

    // const addItem = (e) => {
    //     e.preventDefault();
    //     if(items.indexOf(name) !== -1){
    //         messageApi.warning('You already have this theme');
    //         return;
    //     }
    //     setItems([...items, name || `New theme ${items.length}`]);
    //     setName('');
    //     setTimeout(() => {
    //         inputRef.current?.focus();
    //     }, 0);
    // };


    return (
        <div className='quiz'>
            {contextHolder}
            <div className='container mt-4 mb-4 d-flex justify-content-between'>
                <Menu/>
                <PlusCircleTwoTone style={{ fontSize: '28px'}}  className='add-quiz-icon' onClick={handleAddQuiz}/>
                <div className='d-flex align-items-center quiz-title' style={{marginLeft: '10px'}}>QUIZ</div>
            </div>

            <div className="quiz-container">
                <div className='quiz-content-container ml-4 quiz-content-no-bgcolor quiz-content-title'>
                    <span className="fs-5 fw-bold">Last Practice</span>
                        {/* Recent, and display three recent activities including recent question and new created quiz */}

                </div>
                <div className="quiz-content-container">
                        {/* <span className="fs-5 fw-bold">Last Practice</span> */}
                    <div className='container'>
                        {Object.keys(subObj).length !== 0 ? <Card hoverable
                            title={<div className='d-flex justify-content-between'>
                                    <span>{subObj.title}</span>
                                    <span>Submit time: {timeStampToDateTime(subObj.submit_time)}</span>
                            </div>}
                            bordered={true}
                            style={{marginBottom: '16px'}}
                            actions={[
                                <Button type='primary' onClick={(e)=>goQuiz(e, '', '')}>Start Now!</Button>,
                            ]}
                        >
                            <p>{subObj.description}</p>
                        </Card>: <Empty/>}
                        </div>

                </div>
                <div className='quiz-content-container quiz-content-no-bgcolor ml-4 quiz-content-title'>
                    <span className="fs-5 fw-bold">Quiz Set</span>
                </div>
                <div className="quiz-content-container mh-30">
                    {/* <span className="fs-5 fw-bold">Quiz Set</span> */}
                    <div className='container'>
                    <Collapse items={
                            quizListMergeToTheme(quizzes).map((theme, index)=>{
                                console.log('theme.theme_name', theme.theme_name);
                                return {
                                    key: index,
                                    label: theme.theme_name, 
                                    // extra: <span onClick={(e)=>{goQuiz(e, '', '', theme)}} >-></span>,
                                    children: theme.quizUnderTag.map((q, i)=>{
                                        console.log('q',q)
                                        return <Card hoverable key={i}
                                            title={<div className='d-flex justify-content-between'>
                                                <span>{q.title}</span>
                                                <span>{timeStampToDateTime(q.generate_time)}</span>
                                            </div>}
                                            bordered={true}
                                            style={{marginBottom: '16px'}}
                                            actions={[
                                                <><svg key="edit" onClick={(e)=>{goQuiz(e, q)}} xmlns="http://www.w3.org/2000/svg" width="100%" height="16" fill="currentColor" className="bi bi-pencil" viewBox="0 0 16 16">
                                                    <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                                                </svg></>,
                                                <BarChartOutlined key="barChart" onClick={()=>{messageApi.info('The feature is under development.')}}/>,
                                            ]}
                                        >
                                                <p>{q.description}</p>
                                                <br/>
                                                
                                                <div className='d-flex flex-column justify-content-between align-items-end'>
                                                    <div style={{color: `${q.submit_id? 'black':'#ffc107'}`}}>
                                                        {
                                                            !q.submit_id ? <span>Unattempted Exercises</span> : 
                                                                <div>
                                                                    Last submit: 
                                                                    {/* <span style={{fontWeight: 'bold', marginRight: '10px'}}>{subObj[q.quiz_id]?.correct_count}</span> */}
                                                                    <span>{timeStampToDateTime(q.submit_time || null)}</span>
                                                                </div>
                                                        }
                                                    
                                                        
                                                    </div>
                                                </div>
                                        </Card>
                                    })
                                }
                            })
                    }  onChange={()=>{}} />
                    </div>
                    {quizzes.length === 0 ? <div className='d-flex flex-column justify-content-center h-75'><Empty
                        description={
                        <span>
                            You don't have any quiz.
                        </span>
                        }
                        imageStyle={{ height: 100 }}
                    ></Empty></div> : null}
                </div>
                <div className="quiz-content-container quiz-content-no-bgcolor d-flex justify-content-center">
                        <Button type="primary" onClick={()=>{navigate('/test-generator')}}>Create Quiz</Button>
                    </div>
            </div>

            <Spin spinning={spinning} fullscreen='true' />
            <Modal
                open={open}
                title="Practice Mode"
                onCancel={()=>setOpen(false)}
                footer={null}
                centered
            >
                <div className='d-flex justify-content-between'>
                    <Space direction='vertical' className='d-flex align-items-center justify-content-between my-button'>
                    <span>In Order</span>
                        
                        <span>3/10</span>
                    </Space>
                    <Space direction='vertical' className='d-flex align-items-center justify-content-between my-button'>
                        
                    <span>Random Order</span>
                        <span>3/10</span>
                    </Space>
                    <Space direction='vertical' className='d-flex align-items-center justify-content-between my-button'>
                    <span>Wrong Questions</span>
                        <span>3/10</span>
                    </Space>
                </div>
            </Modal>
        </div>
    );
}

export default Quiz;